var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 0H5.33333C2.4 0 0 2.4 0 5.33333V6.66667C0 7.46667 0.533333 8 1.33333 8H30.6667C31.4667 8 32 7.46667 32 6.66667V5.33333C32 2.4 29.6 0 26.6667 0Z",
    fill: "#4858A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 10.6667H1.33333C0.533333 10.6667 0 11.2001 0 12.0001V18.6667C0 21.6001 2.4 24.0001 5.33333 24.0001H26.6667C29.6 24.0001 32 21.6001 32 18.6667V12.0001C32 11.2001 31.4667 10.6667 30.6667 10.6667ZM14.6667 20.0001H6.66667C5.86667 20.0001 5.33333 19.4667 5.33333 18.6667C5.33333 17.8667 5.86667 17.3334 6.66667 17.3334H14.6667C15.4667 17.3334 16 17.8667 16 18.6667C16 19.4667 15.4667 20.0001 14.6667 20.0001ZM25.3333 16.0001H22.6667C21.8667 16.0001 21.3333 15.4667 21.3333 14.6667C21.3333 13.8667 21.8667 13.3334 22.6667 13.3334H25.3333C26.1333 13.3334 26.6667 13.8667 26.6667 14.6667C26.6667 15.4667 26.1333 16.0001 25.3333 16.0001Z",
    fill: "#4858A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/DebitCard.ee68e7deffb28f075bc52cbea5dc823f.svg";
export { ForwardRef as ReactComponent };